export function getFraction(value: number, total: number, precision = 1) {
  const fraction = ((value / total) * 100).toFixed(precision);
  return Number(fraction);
}

export function isSignificant(value: number, total: number, threshold: number = 12.5) {
  const fraction = getFraction(value, total);
  return fraction > threshold;
}
